// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryContent__container-fa06dd {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  flex: 1;
  overflow: hidden;
  user-select: none;
}

.MediaGalleryContent__navigate-a1d88e {
  color: var(--addition-50_70);
  background-color: var(--addition-110_40);
  position: absolute;
  top: 50%;
  left: var(--gallery-view-padding);
  z-index: 2;
  transform: translateY(-50%);
  opacity: 0;
  transition: opacity 200ms ease-in-out;
}

.MediaGalleryContent__navigate-a1d88e:last-child {
  left: auto;
  right: var(--gallery-view-padding);
}

.MediaGalleryContent__navigate-a1d88e:focus {
  color: var(--addition-50_70);
  background-color: var(--addition-110_40);
}

.MediaGalleryContent__navigate-a1d88e:hover,
.MediaGalleryContent__navigate-a1d88e:focus-visible {
  color: var(--addition-50);
  background-color: var(--addition-110_50);
}

.MediaGalleryContent__navigate-a1d88e:active {
  color: var(--addition-50);
  background-color: var(--addition-110_60);
}

.MediaGalleryContent__navigate-a1d88e.MediaGalleryContent__show-f51b82 {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryContent/MediaGalleryContent.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,OAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,4BAAA;EACA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,iCAAA;EACA,UAAA;EACA,2BAAA;EACA,UAAA;EACA,qCAAA;AACF;;AAEA;EACE,UAAA;EACA,kCAAA;AACF;;AAEA;EACE,4BAAA;EACA,wCAAA;AACF;;AAEA;;EAEE,yBAAA;EACA,wCAAA;AACF;;AAEA;EACE,yBAAA;EACA,wCAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: auto;\n  margin-bottom: auto;\n  flex: 1;\n  overflow: hidden;\n  user-select: none;\n}\n\n.navigate {\n  color: var(--addition-50_70);\n  background-color: var(--addition-110_40);\n  position: absolute;\n  top: 50%;\n  left: var(--gallery-view-padding);\n  z-index: 2;\n  transform: translateY(-50%);\n  opacity: 0;\n  transition: opacity 200ms ease-in-out;\n}\n\n.navigate:last-child {\n  left: auto;\n  right: var(--gallery-view-padding);\n}\n\n.navigate:focus {\n  color: var(--addition-50_70);\n  background-color: var(--addition-110_40);\n}\n\n.navigate:hover,\n.navigate:focus-visible {\n  color: var(--addition-50);\n  background-color: var(--addition-110_50);\n}\n\n.navigate:active {\n  color: var(--addition-50);\n  background-color: var(--addition-110_60);\n}\n\n.navigate.show {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGalleryContent__container-fa06dd`,
	"navigate": `MediaGalleryContent__navigate-a1d88e`,
	"show": `MediaGalleryContent__show-f51b82`
};
module.exports = ___CSS_LOADER_EXPORT___;
